exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cardCollapseContainer{background:#242527 0 0 no-repeat padding-box;border-radius:20px;opacity:1}#cardCollapseContainer .cardCollapsetitle{text-align:center;font:normal normal 700 1.2em Segoe UI;letter-spacing:0;color:#fff;opacity:1;border-bottom:6px solid #121212}#cardCollapseContainer .cardCollapseSubtitle{text-align:right;font:normal normal 700 1.2em Segoe UI;letter-spacing:0;color:#fff}#cardCollapseContainer .nb{text-align:left;font:normal normal 700 1.2em Segoe UI;letter-spacing:0;color:#9561e2;opacity:1}", ""]);

// exports
